import LabServiceModel from "../LabServiceModel";
import ManagedListModel from "@/models/lab/ManagedListModel";
import AttributeListKinModel from "@/models/lab/AttributeListKinModel";
import AttributeListKinCollection from "@/collections/lab/AttributeListKinCollection";

export default class AttributeListModel extends LabServiceModel {
  modelName() {
    return "attribute-list";
  }
  defaults() {
    return {
      id: null,
      managed_list_id: null,
      parent_id: null,
      value: null,
      default: null,
      created_at: null,
      updated_at: null,
      deleted_at: null,
      managed_list: {},
      parent: {},
      children: []
    };
  }
  mutations() {
    return {
      id: val => this.nullStringMutator(val),
      managed_list_id: val => this.nullStringMutator(val),
      parent_id: val => this.nullStringMutator(val),
      value: val => this.nullStringMutator(val),
      default: val => this.nullStringMutator(val),
      created_at: val => this.nullStringMutator(val),
      updated_at: val => this.nullStringMutator(val),
      deleted_at: val => this.nullStringMutator(val)
    };
  }
  validation() {
    return {};
  }
  getManagedList() {
    return this.getRelatedModel(ManagedListModel, "managed_list");
  }
  getParent() {
    return this.getRelatedModel(AttributeListKinModel, "parent");
  }
  getChildren() {
    return this.getRelatedCollection(
      new AttributeListKinCollection(),
      "children"
    );
  }
}
